import { ListSites } from "../../components/ListSites";

export const ListSitesPage = () => {
  return <ListSites />;
};
